import { Box } from "@storyofams/react-ui";
import { SystemProps } from "@storyofams/react-ui";
import Image from "next/image";
import { css } from "styled-components";
import { FixedRatio } from "~components/common/FixedRatio";
import { Media } from "./Media";

type GalleryProps = {
  recipe: any;
} & SystemProps;

export const Gallery = ({ recipe }: GalleryProps) => {
  return (
    <Box>
      {recipe.media_links && recipe.media_links.length > 1 ? (
        <Media media={recipe.media_links} />
      ) : (
        <FixedRatio
          css={css({
            img: {
              borderRadius: "8px",
            },
          })}
        >
          <Image
            priority={true}
            layout="fill"
            objectFit="cover"
            src={
              recipe.media_links && recipe.media_links.length
                ? recipe.media_links[0]
                : recipe?.image.includes("storyblok")
                ? recipe?.image + "/m/500x500"
                : recipe?.image
            }
            alt="recipe_image"
            width={517}
            height={517}
          />
        </FixedRatio>
      )}
    </Box>
  );
};
